import script from "./HelloWorld.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&setup=true&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=e8f58eac&scoped=true&lang=css"

import exportComponent from "/Users/andrias/Vue/wordle-solver/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8f58eac"]])

export default __exports__